import ExpandableVolumeSnippet from "../../../../contents/docs/self-host/deploy/snippets/expandable-volume";
import * as React from 'react';
export default {
  ExpandableVolumeSnippet,
  React
};